module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGF01-efcee4fe3c2e2d10987bb695c7327771.png";